export default __webpack_public_path__ + "static/media/accounts_cover.feddfba1.jpg";